import { createSelector } from '@reduxjs/toolkit';
import { userPropertiesForCurrentOrganization } from './user/userPropertiesForCurrentOrganization';

export const todoListHideAfterDaysOption = createSelector(
  [userPropertiesForCurrentOrganization],
  function (userProperties): number {
    return userProperties.todoListHideAfterDaysOption || 1;
  },
);
